import {
  gql,
  OperationVariables,
  QueryHookOptions,
  useQuery,
} from '@apollo/client';

import { Exporter } from './types';

type IGetExporters = {
  getExporters: Exporter[];
};

export const GET_EXPORTERS_PUBLIC = gql`
  query getExportersPublic {
    getExporters {
      name
      enabled
      exporter
      exporter_id

      ... on SplunkHecLogsExporter {
        hec_url
        tenant
        tls {
          verify_certificate
        }
      }

      ... on ElasticsearchExporter {
        bulk {
          index
        }
        endpoint
        tls {
          verify_certificate
        }
      }

      ... on HttpExporter {
        headers {
          name
          value
        }
        tls {
          verify_certificate
        }
        uri
      }

      ... on LogscaleExporter {
        tenant
        url
        tls {
          verify_certificate
        }
        __typename
      }
    }
  }
`;

export const useGetExportersPublic = (
  options: QueryHookOptions<IGetExporters, OperationVariables>,
) => {
  return useQuery<IGetExporters>(GET_EXPORTERS_PUBLIC, {
    ...options,
  });
};
